<template>
	<div ref="CarePopup" class="dialog-container">
		<div class="dialog scroll" style="transform: translate(0, -400px); max-width: 960px;">
			<form @submit.stop="doValidation()">
				<div class="home-title">
					<div class="title-left" style="font-size: 20px;">
						<img style="width: 14px; height: 22px;" src="@/assets/images/login/care_icon.png" />
						<span>출산 후 데이터 상세정보</span>
					</div>
				</div>
				<div class="center dialog-flex">
					<div>
						<span class="dialog-tag">참여자 정보</span>
						<table class="tb-crud-horizon popup-table" style="margin-top: 12.5px;">
							<colgroup>
								<col width="140px" />
								<col width="auto" />
								<col width="140px" />
								<col width="auto" />
							</colgroup>
							<tbody>
								<tr style="border-top: 1px solid #191C26">
									<th>참여자 번호</th>
									<td>
									</td>
									<th>이름</th>
									<td>
									</td>
								</tr>
								<tr>
									<th>전화번호</th>
									<td>
									</td>
									<th>분만일</th>
									<td>
									</td>
								</tr>
								<tr>
									<th>응급지원</th>
									<td>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="center dialog-flex">
					<div>
						<span class="dialog-tag">데이터 상세</span>
						<table class="tb-crud-horizon popup-table" style="margin-top: 12.5px;">
							<colgroup>
								<col width="140px" />
								<col width="auto" />
								<col width="140px" />
								<col width="auto" />
							</colgroup>
							<tbody>
								<tr style="border-top: 1px solid #191C26">
									<th>분류</th>
									<td>
									</td>
								</tr>
								<tr>
									<th>건강 상태</th>
									<td>
									</td>
									<th>건강 상태 상세 정보</th>
									<td>
									</td>
								</tr>
								<tr>
									<th>중환자실 입원</th>
									<td>
									</td>
									<th>입원 날짜</th>
									<td>
									</td>
								</tr>
								<tr>
									<th>입원 사유</th>
									<td>
									</td>
									<th>모유수유</th>
									<td>
									</td>
								</tr>
								<tr>
									<th>업데이트 일시</th>
									<td>
									</td>
									<th>전송 일시</th>
									<td>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="bottom" style="display: flex; justify-content: center; column-gap: 10px; margin-top: 50px;">
					<button type="button" class="btn-cancel fright" title="Cancel" @click="doCancel()">
						닫기
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";

export default {
	name: "CarePopup",
	created() {
		this.logger.debug(this, "created()");
		this.firstRegistDate = moment().format("YYYY-MM-DD");
		this.firstRegistUserId = this.userInfo.userId;
		this.firstRegistUserName = this.userInfo.userName;
		this.selectSortOrder();
	},
	data() {
		return {
			item: {},
		};
	},
	methods: {
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to register the current Question Group?", "Question", "question").then(() => {
							EventBus.$emit("field-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		selectSortOrder() {
			this.logger.debug(this, "selectSortOrder()");

			axios
				.post(this.config.contextRoot + "/field/selectSortOrder.do", this.item)
				.then((response) => {
					console.log(response);

					this.item = response.data.item;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				})
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");
			axios
				.post(this.config.contextRoot + "/field/insertGroup.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("Complete", "Success", "success").then(() => {
							// location.reload();
							this.$parent.selectProjectList();
							this.$parent.selectQuestionGroupList();
							this.doClose();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("취소하시겠습니까?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.CarePopup.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.CarePopup.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("project-cancel", "isDataPopup");
			}.bind(this), 410);
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
.popup-table th{
	background-color: #F8F9FB;
}
.popup-table tr:first-child > th{
	border-top: 1px solid #191C26
}
.popup-table tr:first-child > td{
	border-top: 1px solid #191C26
}
.dialog-tag{
	font-size: 18px;
	font-weight: bold;
}
.dialog-flex{
	display: flex;
    column-gap: 40px;
    justify-content: space-between;
	margin: 
}
.dialog-flex > div{
	width: 100%;
}
.popup-table td{
	border-left: 1px solid #ddd;
	border-right: 1px solid #ddd;
}
.popup-table td:last-child{
	border-right: none;
}
</style>